import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../usercomponents/SideBar';
import TopNavBar from '../usercomponents/TopNavBar';
import Footer from '../usercomponents/Footer';

const apiUrl = process.env.REACT_APP_API_URL;

function formatDeadline(v) {
  if (!v) return null;
  return new Date(v).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

function statusInfo(a) {
  const deadlinePassed = a.deadline && new Date(a.deadline) < new Date();
  if (a.submission_id && a.reviewed_at) {
    return { label: `Reviewed: ${a.marks}${a.max_marks !== null && a.max_marks !== undefined ? ` / ${a.max_marks}` : ''}`, className: 'bg-success-subtle text-success-emphasis' };
  }
  if (a.submission_id && a.submitted_at) {
    return { label: 'Review Pending', className: 'bg-warning-subtle text-warning-emphasis' };
  }
  if (deadlinePassed) {
    return { label: 'Deadline Passed', className: 'bg-danger-subtle text-danger-emphasis' };
  }
  return { label: a.deadline ? `Submit by ${formatDeadline(a.deadline)}` : 'Open', className: 'bg-main-50 text-main-600' };
}

function StudentAssignments() {
  const navigate = useNavigate();
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const getToken = () => JSON.parse(sessionStorage.getItem('studentSession'))?.token;

  const fetchAssignments = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const token = getToken();
      if (!token) { setError('Authentication required.'); setLoading(false); return; }
      const response = await axios.get(`${apiUrl}/api/student/assignments`, { headers: { Authorization: `Bearer ${token}` } });
      if (response.data.success) setAssignments(response.data.assignments || []);
      else setError(response.data.message || 'Failed to fetch assignments.');
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching assignments.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAssignments(); }, [fetchAssignments]);

  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body px-3">
          <div className="breadcrumb mb-24">
            <ul className="d-flex align-items-center gap-2 list-unstyled">
              <li><Link to="/dashboard" className="text-gray-200 text-15 hover-text-main-600 text-decoration-none">Home</Link></li>
              <li><span className="text-gray-500 d-flex align-items-center"><i className="ph ph-caret-right" /></span></li>
              <li><span className="text-main-600 text-15">Assignments</span></li>
            </ul>
          </div>

          {error && <div className="alert alert-danger mb-20">{error}</div>}

          {loading ? (
            <div className="text-center py-40"><div className="spinner-border text-main-600" /></div>
          ) : assignments.length === 0 ? (
            <div className="card shadow-sm border-0"><div className="card-body text-center py-40 text-gray-400">
              No assignments have been given to your batch yet.
            </div></div>
          ) : (
            <div className="row g-16">
              {assignments.map((a) => {
                const status = statusInfo(a);
                return (
                  <div className="col-md-6" key={a.id}>
                    <div className="card shadow-sm border-0 h-100">
                      <div className="card-body p-20">
                        <div className="fw-bold text-16 mb-4">{a.title}</div>
                        <div className="text-13 text-gray-500 mb-12">{a.coursename}</div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className={`badge ${status.className}`}>{status.label}</span>
                          <button type="button" className="btn btn-main rounded-pill py-6 px-16" onClick={() => navigate(`/assignments/${a.id}`)}>
                            View
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
}

export default StudentAssignments;
